// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eCustomerPhotoTypeFilterTitle{font-size:18px;font-family:\"openSansBold\",\"serif\";font-weight:bold}.bCustomerPhotoTypeFilter{text-align:center;margin-top:10px;border-top:6px solid #edeeee}.eCustomerPhotoTypeFilterTextWrapper{text-align:left}.eCustomerPhotoTypeFilterText{font-size:14px;line-height:2;cursor:pointer}", ""]);
// Exports
module.exports = exports;
